import { api } from './api';

export const transportationApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // general info
        getTransporationLocations: builder.query({
            query: (body) => ({
                url: 'api/transport/',
                method: 'POST',
                body,
                headers: {
                    SUBTYPE: 'get_transport_locations'
                }
            })
        }),
        getTransporationPatients: builder.query({
            query: (body) => ({
                url: 'api/transport/',
                method: 'POST',
                body,
                headers: {
                    SUBTYPE: 'get_transport_patient_by_location'
                }
            })
        }),
        getTransporationCareAids: builder.query({
            query: (body) => ({
                url: 'api/transport/',
                method: 'POST',
                body,
                headers: {
                    SUBTYPE: 'get_personal_care_aide'
                }
            })
        }),
        getTransportationList: builder.query({
            query: (payload) => ({
                url: 'api/transport/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),
        saveTransporationLog: builder.mutation({
            query: (payload) => ({
                url: `api/transport/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'CREATE'
                }
            })
            // invalidatesTags: ['ScheduleList', 'TharapistScheduleList', 'EventDetails']
        }),
        getTransportationReportList: builder.query({
            query: (payload) => ({
                url: 'api/transport/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'get_transport_report'
                }
            })
            // providesTags: ['ServiceTypesList']
        }),
        transportationBulkSign: builder.mutation({
            query: (payload) => ({
                url: 'api/transport/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'bulk_sign'
                }
            })
            // invalidatesTags: ['UnsignedReportsList']
        }),
        unlockTransportLog: builder.mutation({
            query: (payload) => ({
                url: '/api/transport/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'unlock'
                }
            })
            // invalidatesTags: ['TransportationList']
        }),
        getTransportHistory: builder.query({
            query: (payload) => ({
                url: '/api/transport/activity/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
            // invalidatesTags: ['TreatmentHistory']
        })
    })
});

export const {
    useLazyGetTransportationListQuery,
    useLazyGetTransportationReportListQuery,
    useGetTransporationCareAidsQuery,
    useGetTransporationLocationsQuery,
    useGetTransporationPatientsQuery,
    useTransportationBulkSignMutation,
    useSaveTransporationLogMutation,
    useUnlockTransportLogMutation,
    useLazyGetTransportHistoryQuery
} = transportationApi;
